import { render, staticRenderFns } from "./organization-process-datasource-form.vue?vue&type=template&id=441f3a96"
import script from "./organization-process-datasource-form.vue?vue&type=script&lang=js"
export * from "./organization-process-datasource-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports